import { render, staticRenderFns } from "./AppNavbarHorizontalLayout.vue?vue&type=template&id=1ae24bf4&scoped=true&"
import script from "./AppNavbarHorizontalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarHorizontalLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarHorizontalLayout.vue?vue&type=style&index=0&id=1ae24bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae24bf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ae24bf4')) {
      api.createRecord('1ae24bf4', component.options)
    } else {
      api.reload('1ae24bf4', component.options)
    }
    module.hot.accept("./AppNavbarHorizontalLayout.vue?vue&type=template&id=1ae24bf4&scoped=true&", function () {
      api.rerender('1ae24bf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-navbar/AppNavbarHorizontalLayout.vue"
export default component.exports